import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const UnavailableNonHubSpotData = () => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.table.collectedForms.unavailableData"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "notApplicable"
    })
  });
};
export default UnavailableNonHubSpotData;